import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { VendorService } from '../proxy/controlling/controllers/vendor.service';

FieldBuilder.setNamespace('Controlling');

export const CUSTOMER_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('sapCode', 'Entity.Customer.SapCode')
    .required()
    .maxLength(10)
    .build(),
  FieldBuilder
    .text('name', 'Entity.Customer.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('vatNumber', 'Entity.Customer.VatNumber')
    .maxLength(20)
    .build(),
  FieldBuilder
    .text('termsOfPayments', 'Entity.Customer.TermsOfPayments')
    .maxLength(10)
    .build(),
  FieldBuilder
    .text('reconAccount', 'Entity.Customer.ReconAccount')
    .maxLength(10)
    .build(),
  FieldBuilder
    .checkbox('isGenericCustomer', 'Entity.Customer.IsGenericCustomer')
    .build(),
  FieldBuilder
    .checkbox('isOwnService', 'Entity.Customer.IsOwnService')
    .build(),
  FieldBuilder
    .text('searchTerm', 'Entity.Customer.SearchTerm')
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('businessArea', 'Entity.Customer.BusinessArea')
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('languageKey', 'Entity.Customer.LanguageKey')
    .maxLength(2)
    .build(),
  FieldBuilder
    .text('isNaturalPerson', 'Entity.Customer.IsNaturalPerson')
    .maxLength(1)
    .build(),
  FieldBuilder
    .number('locationNumber', 'Entity.Customer.LocationNumber')
    .build(),
  FieldBuilder
    .text('oldSapCode', 'Entity.Customer.OldSapCode')
    .maxLength(10)
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
  .foreignKey('vendorId', 'Entity.Vendor', VendorService)
  .display('fantasyName')
  .keyField('id')
  .build(),
];

export const CUSTOMER_CONFIG = {
  entityName: 'Customer',
  localizationKey: 'Controlling::Entity.Customer',
  fields: CUSTOMER_FIELDS,
  permission: 'ControllingContract.Customers',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
